import type { EncryptedPayload } from "./types";

const DB_NAME = "kensin-system";
const STORE_NAME = "secure-store";
const DRAFT_KEY = "encrypted-draft";
const LOCAL_ROUTE_KEY = "encrypted-route";

const openDatabase = () =>
  new Promise<IDBDatabase>((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);

    request.onupgradeneeded = () => {
      request.result.createObjectStore(STORE_NAME);
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });

const runTransaction = async <T>(
  mode: IDBTransactionMode,
  action: (store: IDBObjectStore) => IDBRequest<T>,
) => {
  const db = await openDatabase();
  return new Promise<T>((resolve, reject) => {
    const transaction = db.transaction(STORE_NAME, mode);
    const store = transaction.objectStore(STORE_NAME);
    const request = action(store);

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
    transaction.oncomplete = () => db.close();
    transaction.onerror = () => {
      db.close();
      reject(transaction.error);
    };
  });
};

export const saveDraftPayload = (payload: EncryptedPayload) =>
  runTransaction("readwrite", (store) => store.put(payload, DRAFT_KEY));

export const loadDraftPayload = () =>
  runTransaction<EncryptedPayload | undefined>("readonly", (store) =>
    store.get(DRAFT_KEY),
  );

export const clearDraftPayload = () =>
  runTransaction("readwrite", (store) => store.delete(DRAFT_KEY));

export const saveLocalRoutePayload = (payload: EncryptedPayload) =>
  runTransaction("readwrite", (store) => store.put(payload, LOCAL_ROUTE_KEY));

export const loadLocalRoutePayload = () =>
  runTransaction<EncryptedPayload | undefined>("readonly", (store) =>
    store.get(LOCAL_ROUTE_KEY),
  );
